import moment from "moment";
var BaseNotification = /** @class */ (function () {
    function BaseNotification() {
    }
    BaseNotification.prototype.activate = function (model) {
        this.notification = model.notification;
        this.notificationCenter = model.notificationCenter;
    };
    BaseNotification.prototype.getTime = function (date) {
        var dateConverted = new Date(date);
        return moment(dateConverted).format("MMMM Do YYYY HH:mm");
    };
    return BaseNotification;
}());
export { BaseNotification };
